import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPendingTasks } from '../../../api/accordanceApi';
import { AccordanceType } from '../../../models/AccordanceType';
import { EventType } from '../../../models/EventType';
import SupervisionModal from '../../ProjectDetail/ProjectTabs/Supervision/SupervisionModal/SupervisionModal';
import AccordanceDetail from '../../Util/Modals/AccordanceDetail/AccordanceDetail';
import LinkEventOutlook from '../../Util/Modals/LinkProjectOutlook/LinkEventOutlook';
import PortfolioAccordanceTable from '../PortfolioAccordanceTable/PortfolioAccordanceTable';
import './PendingTasksDetail.scss';
import { useDispatch, useSelector } from 'react-redux';
import FilterIndicators from '../../../models/FilterIndicators';
import { AppMenuTabs } from '../../MenuTabs/userTabsInterface';
import { setIndicatorResponse, setLoading } from '../../../redux/actions/dataTable';
import { getNewFilteredIndicators } from '../../../api/indicatorApi';
import { translateMultipleText } from '../../../services/stringUtil';
import { emptyProjects } from '../../Portfolio/PortfolioUtil';
import { processIndicators } from '../../Portfolio/indicatorHelper';
import { arrayMove } from 'react-sortable-hoc';
import { addIndicators } from '../../../redux/actions/indicators';
import { setCurrentIndicator } from '../../../redux/actions/currentIndicator';
import { ProjectProductTypes } from '../../../models/ProjectProductTypes';
import { updateCreatingOrEditing } from '../../../redux/actions/menuTabs';
// import { tabId0OrCreatingEditing } from '../../Portfolio_R/utils/tab-id-validation';
import { resetIndicatorDetailFilter } from '../../../redux/actions/indicatorDetailFilters';
import Filter from '../../Portfolio/Filter/Filter';

type Props = {
  currentIndicator: any;
};

export const PendingTasksDetail = ({ currentIndicator }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [revisionAccordancesTotal, setRevisionAccordancesTotal] = useState(0);
  const [monitorAccordancesTotal, setMonitorAccordancesTotal] = useState(0);
  const [intergoupAccordancesTotal, setIntergoupAccordancesTotal] = useState(0);
  const [pendigTasksList, setPendigTasksList] = useState<any[]>([]);
  const [showAccordanceDetail, setShowAccordanceDetail] = useState(false);
  const [showCreateReminder, setShowCreateReminder] = useState(false);
  const [selectedProject, setSelectedProject] = useState<any>({});
  const [supervisionActivitiesTotal, setSupervisionActivitiesTotal] = useState(0);
  const [showActivityDetail, setShowActivityDetail] = useState(false);

  const [customEvent, setCustomEvent] = useState<any>({});

  const handleGetPendingTasks = async () => {
    const response: any = await getPendingTasks();
    setRevisionAccordancesTotal(response.revisionCount);
    setMonitorAccordancesTotal(response.monitoringCount);
    setIntergoupAccordancesTotal(response.intergroupCount);
    setPendigTasksList(
      addSortValues([...response.accordances, ...parseActivitiesToAccordanceStructure(response.supervisionPlanItems)]),
    );
    setSupervisionActivitiesTotal(response.supervisionCount);
  };

  // Filter
  const filterIndicators = useSelector<any, FilterIndicators>(state => state.filterIndicators);
  // const stateProjectProductTypes = useSelector<any, FilterIndicators>(
  //   state => state.indicatorPayload.payload.projectProductTypes,
  // );
  const menuTabs = useSelector<any, AppMenuTabs>(state => state.menuTabs);
  const portfolioSelectedTab = menuTabs.portfolioSelectedTab;
  const creatingOrEditing = menuTabs.creatingOrEditing;
  const [isLoading, setIsLoading] = useState(false);
  const [totalProjectsData, setTotalProjectsData] = useState(false);
  const [flag, setFlag] = useState<boolean>(false);

  // const projectTypeFilterChange = {
  //   ...filterIndicators,
  //   common: { ...filterIndicators.common, projectTypeFilters: stateProjectProductTypes },
  //   projectTypeFilters: stateProjectProductTypes,
  // };

  const handleCommonFilterChange = async () => {
    dispatch(setLoading(true));
    setIsLoading(true);

    try {
      const indicatorsToProcess = await getNewFilteredIndicators();
      // {},
      // { projectProductTypes: stateProjectProductTypes },
      // {
      //   ...projectTypeFilterChange.common,
      // },
      dispatch(setIndicatorResponse(indicatorsToProcess));
      startProcessIndicators(
        indicatorsToProcess,
        translateMultipleText(` ${' '} ${portfolioSelectedTab.title}`, t),
        filterIndicators.common.projectTypeFilters,
      );
      setTotalProjectsData(emptyProjects(indicatorsToProcess.totalProjects));
    } catch (err) {
      console.error(err, 'Error fetching data from indicators');
    } finally {
      dispatch(setLoading(false));
      setIsLoading(false);
    }
  };

  const startProcessIndicators = (inds, titleFromTab, projectTypeFilter = [ProjectProductTypes.Loan]) => {
    const result = processIndicators(inds, {
      titleFromTab,
      projectTypeFilter,
    });
    const elementSummary: any = result.find(elem => elem.id === 15);
    const indexSummary: number = result.indexOf(elementSummary);
    const sendEndSummary = arrayMove(result, indexSummary, result.length);

    dispatch(addIndicators(sendEndSummary));
    dispatch(setCurrentIndicator(sendEndSummary?.find(data => data.indicatorKey === 'USER_PENDING_TASKS')));
    setIsLoading(false);
  };

  const handleProject = (accordanceObject: any, isLinkEvent = false) => {
    if (isLinkEvent) {
      setCustomEvent({
        id: accordanceObject.id,
        eventType:
          accordanceObject.supervisionPlanId !== undefined
            ? EventType.SupervisoryAction
            : accordanceObject.accordanceType === AccordanceType.Monitoring
            ? EventType.MonitoringAccordance
            : EventType.RevisionAccordance,
        projectId: accordanceObject.project.id,
        title:
          accordanceObject.supervisionPlanId !== undefined
            ? accordanceObject.description
            : accordanceObject.project.name,
        multiple: [],
      });
      setShowCreateReminder(true);
    } else {
      setSelectedProject(accordanceObject);
      if (accordanceObject.supervisionPlanId !== undefined) {
        setShowActivityDetail(true);
      } else {
        setShowAccordanceDetail(true);
      }
    }
  };

  const hideModal = () => {
    setShowAccordanceDetail(false);
  };

  useEffect(() => {
    handleGetPendingTasks();
  }, [filterIndicators.common]);

  useEffect(() => {
    if (
      filterIndicators.common.coReponsibleDivisions.length > 0 ||
      filterIndicators.common.countryId.length > 0 ||
      filterIndicators.common.divisionId.length > 0 ||
      filterIndicators.common.interestIssues.length > 0 ||
      filterIndicators.common.participantDivisions.length > 0 ||
      filterIndicators.common.regionId.length > 0 ||
      filterIndicators.common.sectors.length > 0 ||
      filterIndicators.common.teamLeaders.length > 0
    )
      handleCommonFilterChange();
    setFlag(true);
    // setDataButtonsFilterState(dataStateButtons);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  useEffect(() => {
    dispatch(resetIndicatorDetailFilter());
    if (
      !menuTabs.firstLoad &&
      // tabId0OrCreatingEditing(menuTabs, creatingOrEditing) &&
      filterIndicators.common.coReponsibleDivisions.length === 0 &&
      filterIndicators.common.countryId.length === 0 &&
      filterIndicators.common.divisionId.length === 0 &&
      filterIndicators.common.interestIssues.length === 0 &&
      filterIndicators.common.participantDivisions.length === 0 &&
      filterIndicators.common.regionId.length === 0 &&
      filterIndicators.common.sectors.length === 0 &&
      filterIndicators.common.teamLeaders.length === 0 &&
      flag
    ) {
      handleCommonFilterChange();
      setFlag(false);
      // setDataButtonsFilterState(dataStateButtons);
      if (creatingOrEditing) {
        dispatch(updateCreatingOrEditing(false));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  const handleCloseSupervisionModal = (refreshData: boolean) => {
    setShowActivityDetail(false);
    if (refreshData) {
      handleGetPendingTasks();
    }
  };

  return (
    <>
      <div className="pending-tasks-detail-container">
        <div className="pending-tasks-header-content">
          <div className="pending-tasks-values-container">
            <div className="date-filter">
              <div className="value">{revisionAccordancesTotal}</div>
              <div className="subtitle">{t('revision_accordances')}</div>
            </div>
          </div>
          <div className="pending-tasks-values-container">
            <div className="date-filter">
              <div className="value">{monitorAccordancesTotal}</div>
              <div className="subtitle">{t('monitor_accordances')}</div>
            </div>
          </div>
          <div className="pending-tasks-values-container">
            <div className="date-filter">
              <div className="value">{intergoupAccordancesTotal}</div>
              <div className="subtitle">{t('inter_group_accordances')}</div>
            </div>
          </div>
          <div className="pending-tasks-values-container">
            <div className="date-filter">
              <div className="value">{supervisionActivitiesTotal}</div>
              <div className="subtitle">{t('supervisory_activities')}</div>
            </div>
          </div>
        </div>
        <div className="table-container">
          <PortfolioAccordanceTable
            accordances={pendigTasksList}
            handleProject={handleProject}
            indicatorKey={currentIndicator.indicatorKey}
          />
          {/* <ProjectCounter
            arrayToCount={pendigTasksList}
            countProjects={true}
            indicatorKey={IndicatorKeyEnum.USER_PENDING_TASKS}
            widthStyle={'1270px'}
            nestedProject={'project'}
          /> */}
        </div>
        <AccordanceDetail
          isOpen={showAccordanceDetail}
          closeModal={hideModal}
          accordance={selectedProject}
          showJustificationModal={() => {}}
          onApproveHandler={() => {}}
          changeAccordanceStatus={() => {}}
        />
        <LinkEventOutlook
          isOpen={showCreateReminder}
          closeModal={() => setShowCreateReminder(false)}
          event={customEvent}
          currentProjectId={customEvent.projectId}
        />
        <SupervisionModal
          modalIsOpen={showActivityDetail}
          openModal={() => setShowActivityDetail(true)}
          closeModal={(refreshData: boolean) => handleCloseSupervisionModal(refreshData)}
          activity={selectedProject}
          currentProjectId={selectedProject.projectId}
        />
      </div>
    </>
  );
};

const parseActivitiesToAccordanceStructure = (list: any[]) => {
  return list.map(item => {
    item.project = { code: item.projectCode, loanNumber: item.loan, name: item.projectName, id: item.projectId };
    item.accordanceType = item.type;
    item.expirationDate = item.plannedDate;
    return item;
  });
};

export const addSortValues = list => {
  return list.map(i => {
    i.typeSortValue = i.supervisionPlanId !== undefined ? i.type + 10 : i.accordanceType;
    return i;
  });
};
